export const GET_IS_FETCHING_AVAILABLE_CANDIDATES =
  "GET_IS_FETCHING_AVAILABLE_CANDIDATES";
export const GET_AVAILABLE_CANDIDATES = "GET_AVAILABLE_CANDIDATES";
export const GET_IS_LOADING_APPLICATION_COMMENTS =
  "GET_IS_LOADING_APPLICATION_COMMENTS";
export const GET_APPLICATION_COMMENTS = "GET_APPLICATION_COMMENTS";
export const GET_BOOKING_APPLICATION_QUESTIONS =
  "GET_BOOKING_APPLICATION_QUESTIONS";
export const GET_IS_LOADING_APPLICATION_QUESTIONS =
  "GET_IS_LOADING_APPLICATION_QUESTIONS";
export const GET_CURRENT_USER_APPLICATION = "GET_CURRENT_USER_APPLICATION";
export const GET_IS_LOADING_CURRENT_USER_APPLICATION =
  "GET_IS_LOADING_CURRENT_USER_APPLICATION";
export const GET_ALL_APPLICATIONS = "GET_ALL_APPLICATIONS";
export const GET_IS_LOADING_ALL_APPLICATIONS =
  "GET_IS_LOADING_ALL_APPLICATIONS";
export const GET_CURRENT_APPLICATION = "GET_CURRENT_APPLICATION";
export const GET_IS_FETCHING_CURRENT_APPLICATION =
  "GET_IS_FETCHING_CURRENT_APPLICATION";
export const GET_CURRENT_APPLICATION_ANSWERS =
  "GET_CURRENT_APPLICATION_ANSWERS";
export const GET_IS_FETCHING_CURRENT_APPLICATION_ANSWERS =
  "GET_IS_FETCHING_CURRENT_APPLICATION_ANSWERS";

const getters = {
  [GET_IS_FETCHING_AVAILABLE_CANDIDATES]: state =>
    state.isFetchingAvailableCandidates,
  [GET_AVAILABLE_CANDIDATES]: state => state.availableCandidates,
  [GET_IS_LOADING_APPLICATION_COMMENTS]: state =>
    state.isLoadingApplicationComments,
  [GET_APPLICATION_COMMENTS]: state => state.applicationComments,
  [GET_IS_LOADING_APPLICATION_QUESTIONS]: state =>
    state.isLoadingApplicationQuestions,
  [GET_BOOKING_APPLICATION_QUESTIONS]: state =>
    state.bookingApplicationQuestions,
  [GET_CURRENT_USER_APPLICATION]: state => state.currentUserApplication,
  [GET_IS_LOADING_CURRENT_USER_APPLICATION]: state =>
    state.isFetchingCurrentUserApplication,
  [GET_ALL_APPLICATIONS]: state => state.allApplications,
  [GET_IS_LOADING_ALL_APPLICATIONS]: state => state.isFetchingAllApplications,
  [GET_CURRENT_APPLICATION]: state => state.currentApplication,
  [GET_IS_FETCHING_CURRENT_APPLICATION]: state =>
    state.isFetchingCurrentApplication,
  [GET_CURRENT_APPLICATION_ANSWERS]: state => state.currentApplicationAnswers,
  [GET_IS_FETCHING_CURRENT_APPLICATION_ANSWERS]: state =>
    state.isFetchingCurrentApplicationAnswers
};

export default getters;
